<template>
<div>
  <transition name="slide-fade" mode="out-in">
    <keep-alive>
      <component :is="componentsId" :customerOldId="customerOldId" :customerNewId="customerNewId" :houseId="houseId"></component>
    </keep-alive>
  </transition>
</div>
</template>

<script>
import SaleCarryOverList from "./SaleCarryOverList.vue";
import SaleCarryOverMain from "./SaleCarryOverMain.vue";
export default {
  name: "SaleCarryOver",
  components:{SaleCarryOverList,SaleCarryOverMain},
  provide(){
    return{
      setComponents:this.setComponents,
    }
  },
  props:{
    customerOldId:[Number,String],
    customerNewId:[Number,String],
    houseId:[Number,String],
    saleType:[Number,String]
  },
  activated() {
    if(!this.customerNewId){
      this.setComponents("SaleCarryOverList")
    }
  },
  data(){
    return{
      componentsId:"SaleCarryOverMain",
    }
  },
  methods:{
    setComponents(componentsId){
      this.componentsId=componentsId;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/SaleCarryOver.vue